import React, { useState, useEffect, useRef } from "react";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Col, Row, Card, Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import toast, { Toaster } from "react-hot-toast";

import {
  getBranchDetail,
  getBranchProducts,
  updateBranchProducts,
} from "services/branchServices";

import { bGId } from "common/constants/constants";

import Loader from "components/common/loader/Loader";
import ProductDeactivated from "components/common/ProductModal/ProductDeactivated";
import "./branches.scss";
import { useTranslation } from "react-i18next";
const BranchDetails = ({ handleBranchName, handleTab }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [detail, setDetail] = useState({});
  const [branchProducts, setBranchProducts] = useState([]);
  const [showProductModal, setShowProductModal] = useState(false);
  const [clickedProduct, setClickedProduct] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [targetProduct, setTargetProduct] = useState({});
  const { contactPerson = {}, branch = {} } = detail;
  const {
    branchId = "",
    branchName = "",
    branchCode = "",
    branchLocation = "",
    ownedSince = "",
    userCount = "",
    b2bCount = "",
    b2cCount = "",
    balanceTotal = "",
    branchInformation = "",
  } = branch;

  const location = useLocation();

  const {
    contactPersonId = "",
    firstName = "",
    lastName = "",
    email = "",
    phoneNumber = "",
  } = contactPerson ? contactPerson : {};

  const branchDetailHandler = async () => {
    let pathIds = {
      branchId: id,
      bankId: location.state,
      bankgroupsId: bGId,
    };
    const result = await getBranchDetail(pathIds);
    if (result.success) {
      const { branchName } = result.payLoad?.branch || { branchName: "" };
      handleBranchName(branchName);
      setDetail(result?.payLoad);
    }
  };
  const branchProductsHandler = async () => {
    let pathIds = {
      branchId: id,
      bankId: location.state,
      bankgroupsId: bGId,
    };
    setIsLoading(true);
    const result = await getBranchProducts(pathIds);

    if (result.success) {
      let newBranchProducts = result.payLoad.map((product) => {
        return {
          ...product,
          assigned: product.assigned === "Active" ? true : false,
        };
      });
      setIsLoading(false);
      setBranchProducts(newBranchProducts);
    } else {
    }
  };

  const setProductAssignment = (id) => {
    const newBranchProducts = branchProducts.map((product) => {
      if (product.productId === id) {
        return { ...product, assigned: !product.assigned };
      }
      return product;
    });
    setBranchProducts(newBranchProducts);
  };
  const handleUpdateBranchProducts = async () => {
    setBtnLoader(true);
    const assignedProducts = [];
    branchProducts.forEach((product) => {
      let updateProduct = {};
      updateProduct.productId = product.productId;
      updateProduct.isActive = product.assigned ? "#Active" : "#InActive";
      assignedProducts.push(updateProduct);
    });

    let pathIds = {
      branchId: id,
      bankId: location.state,
      bankgroupsId: bGId,
    };
    const payLoad = assignedProducts;
    const result = await updateBranchProducts(pathIds, payLoad);

    if (!result.success) {
      let updatedBranchProducts = [];
      branchProducts.forEach((product) => {
        if (product.productId === targetProduct.productId) {
          updatedBranchProducts.push({ ...product, assigned: false });
        } else updatedBranchProducts.push(product);
      });
      setBranchProducts(updatedBranchProducts);
      toast.error(result?.message);
    } else {
      branchProductsHandler();
    }

    setBtnLoader(false);
  };

  const handleProductsInputClicked = (product) => {
    let { productId } = product;
    setProductAssignment(productId);
    setClickedProduct(product);
    setShowProductModal(true);
  };
  const handleCancelChangeStatus = () => {
    setShowProductModal(false);
    setProductAssignment(clickedProduct.productId);
    setClickedProduct({});
  };
  const handleConfirmChangeStatus = async () => {
    await handleUpdateBranchProducts();
    setShowProductModal(false);
  };

  useEffect(() => {
    branchDetailHandler();
    branchProductsHandler();
  }, []);

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <Row className="branch-details">
          {showProductModal && (
            <ProductDeactivated
              show={showProductModal}
              handleClose={handleCancelChangeStatus}
              handleConfirm={handleConfirmChangeStatus}
              product={clickedProduct}
              branchName={branchName}
              btnLoader={btnLoader}
            />
          )}

          <Col md={4}>
            <p style={{ fontWeight: "bold" }}>{t("balance-total-h1")}</p>
            <h6>{balanceTotal}</h6>
            <p className="mt-5" style={{ fontWeight: "bold" }}>
              {t("general-info")}
            </p>
            <p>{branchInformation}</p>
            <p className="info">{t("name")}</p>
            <p className="infobody">{branchName}</p>
            <p className="info">{t("location")}</p>
            <p className="infobody">{branchLocation}</p>
            <p className="mt-4" style={{ fontWeight: "bold" }}>
              {t("owned-products")}
            </p>
            <p>{t("product-access-text")}</p>
            {branchProducts?.map((product, index) => {
              const {
                productId = "",
                productKey = "",
                translatedValue = "",
                productDescription = "",
                imageUrl = "",
                ownedSince = "",
                revenueTranslatedValue = "",
                assigned = "",
              } = product;
              return (
                <>
                  <div className=" mt-4 d-flex">
                    <img
                      src={`/assets/icons${imageUrl}`}
                      width={30}
                      height={30}
                    />
                    <div className="d-flex w-100 justify-content-between align-items-start">
                      <p className="px-2">
                        {translatedValue}
                        <p className="info infobody">
                          {assigned ? t("owned-since") : null}
                        </p>
                        <p>
                          {assigned
                            ? ownedSince &&
                            ownedSince
                              .toLocaleString("en-US")
                              .split("T")[0]
                              .split("-")
                              .reverse()
                              .join(".")
                            : null}
                        </p>
                      </p>
                      <input
                        className="checkbox-input"
                        type="checkbox"
                        aria-label="checkbox 1"
                        name="gecco"
                        checked={assigned}
                        onClick={() => {
                          handleProductsInputClicked(product);
                          setTargetProduct({ productId });
                        }}
                      />
                    </div>
                  </div>
                  <hr></hr>
                </>
              );
            })}
          </Col>
          <Col md={4}>
            <p style={{ fontWeight: "bold" }}>{t("contact-person")}</p>
            <p className="info">{t("name")}</p>
            <p className="infobody">{`${firstName} ${lastName}`}</p>
            <p className="info">{t("email")}</p>
            <p className="infobody">{`${email}`}</p>
            <p className="info">{t("phone-no")}</p>
            <p className="infobody">{phoneNumber}</p>
          </Col>
          <Col md={4}>
            <Card className="box">
              <Card.Body>
                <Card.Text>
                  <p style={{ fontWeight: "bold" }}>{t("shortcuts")}</p>
                  <p>{t("shortcuts-description")}</p>
                </Card.Text>
                <Button
                  className="branch-btn mt-2"
                  variant="btn-error"
                  onClick={() => {
                    navigate("/user-management");
                  }}
                >
                  {t("user-management")}
                </Button>
                <br></br>
                <Button
                  className="branch-btn  my-3"
                  variant="btn-error"
                  onClick={() => {
                    navigate("/payment");
                  }}
                >
                  {t("payment")}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default BranchDetails;
